import { Box, makeStyles, Typography } from "@material-ui/core";
import { COLOR_ARRAY } from "src/config/styleConfig";

const useStyle = makeStyles(() => ({
  level: {
    height: 10,
    marginRight: 4,
  },
}));

export default function VectorMetric({ ranges, categories, ...props }) {
  const cls = useStyle();
  const _len = ranges.length;

  return (
    <Box {...props}>
      <Box display="flex">
        {ranges.map((element, index) => {
          if (index === 0)
            return (
              <div
                key={index}
                className={cls.level}
                style={{
                  borderTopLeftRadius: 4,
                  borderBottomLeftRadius: 4,
                  background: COLOR_ARRAY[index],
                  flex: element,
                }}
              ></div>
            );
          else if (index === _len - 1)
            return (
              <div
                key={index}
                className={cls.level}
                style={{
                  borderTopRightRadius: 4,
                  borderBottomRightRadius: 4,
                  background: COLOR_ARRAY[index],
                  flex: element,
                }}
              ></div>
            );
          return (
            <div key={index} className={cls.level} style={{ background: COLOR_ARRAY[index], flex: element }}></div>
          );
        })}
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
        {categories.map((number, index) => (
          <Typography key={index} color="textSecondary" style={{ fontSize: 12, fontWeight: 400 }}>
            {number}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
